export default __webpack_public_path__ + "static/screen-2-0ac61cc8fd0cd74f025e2b6e8e287e30.png";